import { useEffect, useState } from "react";

// Pie de página global: marca RedesIP con enlace, año y hora en vivo.
export default function Footer() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  return (
    <footer className="border-t border-slate-200 py-3 text-center text-[11px] text-slate-400">
      © {now.getFullYear()}{" "}
      <a href="https://redesip.org" target="_blank" rel="noopener noreferrer"
        className="font-semibold text-slate-500 hover:text-brand-600 hover:underline">
        Redes IP, CA · redesip.org
      </a>{" "}
      · <span className="tabular-nums">{now.toLocaleString("es", { dateStyle: "medium", timeStyle: "medium", timeZone: "America/Caracas" })}</span>
    </footer>
  );
}
